<template>
	<div class="main-content">
		<div class="center-body">
			<Nav />
			
			<!-- 第一层（专业技术服务保障板块） -->
			<div class="container">
				<div style="width: 1200px; margin: 0 auto; text-align: center;">
					<!-- 标题区域 -->
					<div  style="color: #000; font-size: 44px; font-weight: 400; margin-bottom: 45px;text-align: center;padding-top: 80px;">专业技术服务保障</div>
					<div style="font-size: 14px; color: #666; margin-bottom: 100px;">
						凭借严谨的顾问咨询、专业的实施交付和全天候的售后支持，确保每个项目成功落地、稳定运行。
					</div>

					<div style="display: flex; gap: 30px; justify-content: center;">
						<div 
							class="service-card" 
							:class="{ active: currentCard === 1 }"
							@mouseenter="currentCard = 1"
							@mouseleave="currentCard = 0"
							style="width: 380px; height: 720px; border-radius: 8px; background: #ffffffa3;box-shadow: 0px 0px 10px #eee;"
						>
							<div style="padding: 30px; text-align: left; height: 100%; display: flex; flex-direction: column; justify-content: space-between;">
								<div>
									<div style="font-size: 20px; font-weight: 600; color: #333; margin-bottom: 8px;">顾问服务</div>
									<div style="font-size: 14px; color: #666; margin-bottom: 20px;border-bottom: 1px dashed #eee;padding-bottom: 20px;">严谨的顾问咨询</div>
									
									<ul style="list-style: none; padding: 0; margin: 0;">
										<li style="display: flex; align-items: flex-start; margin-bottom: 20px; padding-top: 20px;">
											<div style="width: 28px; height: 28px; background: #e1f5ff; border-radius: 4px; display: flex; justify-content: center; align-items: center; margin-right: 12px; flex-shrink: 0;">
												<span style="color: #0288d1; font-size: 16px;">📊</span>
											</div>
											<div style="font-size: 14px; color: #666;line-height: 18px;">
												<strong style="color: #333;height: 30px;line-height: 30px;">系统选型</strong><br>
												提供专业的系统选型服务和指导，充分剖析客户的实际业务场景、生产特点以及信息化需求，为企业量身定制适配方案。
											</div>
										</li>
										<li style="display: flex; align-items: flex-start; margin-bottom: 20px;padding-top: 20px;">
											<div style="width: 28px; height: 28px; background: #e1f5ff; border-radius: 4px; display: flex; justify-content: center; align-items: center; margin-right: 12px; flex-shrink: 0;">
												<span style="color: #0288d1; font-size: 16px;">🔍</span>
											</div>
											<div style="font-size: 14px; color: #666;line-height: 18px;">
												<strong style="color: #333;height: 30px;line-height: 30px;">诊断分析</strong><br>
												专业的生产流程诊断，通过现场调研分析企业在营收、管理等方面的问题，提供针对性解决方案。
											</div>
										</li>
										<li style="display: flex; align-items: flex-start; margin-bottom: 20px;padding-top: 20px;">
											<div style="width: 28px; height: 28px; background: #e1f5ff; border-radius: 4px; display: flex; justify-content: center; align-items: center; margin-right: 12px; flex-shrink: 0;">
												<span style="color: #0288d1; font-size: 16px;">💡</span>
											</div>
											<div style="font-size: 14px; color: #666;line-height: 18px;">
												<strong style="color: #333;height: 30px;line-height: 30px;">智慧改造</strong><br>
												以行业先进经验为核心，结合行业案例积累，为企业打造专属的改造升级方案，降低成本并提升竞争力。
											</div>
										</li>
										<li style="display: flex; align-items: flex-start;padding-top: 20px;">
											<div style="width: 28px; height: 28px; background: #e1f5ff; border-radius: 4px; display: flex; justify-content: center; align-items: center; margin-right: 12px; flex-shrink: 0;">
												<span style="color: #0288d1; font-size: 16px;">🎯</span>
											</div>
											<div style="font-size: 14px; color: #666;line-height: 18px;">
												<strong style="color: #333;height: 30px;line-height: 30px;">精益指导</strong><br>
												提供精益管理培训，帮助企业建立一套完整的信息化技术管理体系，构建“效率库”运营模式。
											</div>
										</li>
									</ul>
								</div>

								<div style="text-align: center;">
																<button style="padding: 10px 24px; background: #000; color: #fff; border: none; border-radius: 4px; cursor: pointer; width: 40%;">
									联系我们
								</button>
								</div>
	
							</div>
						</div>

			
						<div 
							class="service-card" 
							:class="{ active: currentCard === 2 }"
							@mouseenter="currentCard = 2"
							@mouseleave="currentCard = 0"
							style="width: 380px; height: 720px;  border-radius: 8px; background: #ffffffa3;box-shadow: 0px 0px 10px #eee;"
						>
							<div style="padding: 30px; text-align: left; height: 100%; display: flex; flex-direction: column; justify-content: space-between;">
								<div>
									<div style="font-size: 20px; font-weight: 600; color: #333; margin-bottom: 8px;">实施服务</div>
									<div style="font-size: 14px; color: #666; margin-bottom: 20px;border-bottom: 1px dashed #eee;padding-bottom: 20px;">专业的交付团队</div>
									
									<ul style="list-style: none; padding: 0; margin: 0;">
										<li style="display: flex; align-items: flex-start; margin-bottom: 20px;padding-top: 20px;">
											<div style="width: 28px; height: 28px; background: #e1f5ff; border-radius: 4px; display: flex; justify-content: center; align-items: center; margin-right: 12px; flex-shrink: 0;">
												<span style="color: #0288d1; font-size: 16px;">📦</span>
											</div>
											<div style="font-size: 14px; color: #666;line-height: 18px;">
												<strong style="color: #333;height: 30px;line-height: 30px;">敏捷实施</strong><br>
												为企业快速导入系统，梳理系统实施配置，提供的实施方法论基于多年实践经验总结而成。
											</div>
										</li>
										<li style="display: flex; align-items: flex-start; margin-bottom: 20px;padding-top: 20px;">
											<div style="width: 28px; height: 28px; background: #e1f5ff; border-radius: 4px; display: flex; justify-content: center; align-items: center; margin-right: 12px; flex-shrink: 0;">
												<span style="color: #0288d1; font-size: 16px;">📤</span>
											</div>
											<div style="font-size: 14px; color: #666;line-height: 18px;">
												<strong style="color: #333;height: 30px;line-height: 30px;">项目交付</strong><br>
												采用敏捷实施方法帮助客户实现系统的快速部署，保障客户的所有项目100%交付，不负客户信任。
											</div>
										</li>
										<li style="display: flex; align-items: flex-start; margin-bottom: 20px;padding-top: 20px;">
											<div style="width: 28px; height: 28px; background: #e1f5ff; border-radius: 4px; display: flex; justify-content: center; align-items: center; margin-right: 12px; flex-shrink: 0;">
												<span style="color: #0288d1; font-size: 16px;">📚</span>
											</div>
											<div style="font-size: 14px; color: #666;line-height: 18px;">
												<strong style="color: #333;height: 30px;line-height: 30px;">系统培训</strong><br>
												系统上线前的培训是必不可少的环节，通过上门服务的培训方式让客户熟练掌握系统操作。
											</div>
										</li>
										<li style="display: flex; align-items: flex-start;padding-top: 20px;">
											<div style="width: 28px; height: 28px; background: #e1f5ff; border-radius: 4px; display: flex; justify-content: center; align-items: center; margin-right: 12px; flex-shrink: 0;">
												<span style="color: #0288d1; font-size: 16px;">🔧</span>
											</div>
											<div style="font-size: 14px; color: #666;line-height: 18px;">
												<strong style="color: #333;height: 30px;line-height: 30px;">二次开发</strong><br>
												随着企业战略及业务发展，企业对信息化建设需求改变，可提供根据需求支持企业客户自主进行二次开发。
											</div>
										</li>
									</ul>
								</div>

								<div style="text-align: center;">
																	<button style="padding: 10px 24px; background: #000; color: #fff; border: none; border-radius: 4px; cursor: pointer; width: 40%;">
									联系我们
								</button>
								</div>

							</div>
						</div>

				
						<div 
							class="service-card" 
							:class="{ active: currentCard === 3 }"
							@mouseenter="currentCard = 3"
							@mouseleave="currentCard = 0"
							style="width: 380px; height: 720px; box-shadow: 0px 0px 10px #eee; border-radius: 8px; background: #ffffffa3;"
						>
							<div style="padding: 30px; text-align: left; height: 100%; display: flex; flex-direction: column; justify-content: space-between;">
								<div>
									<div style="font-size: 20px; font-weight: 600; color: #333; margin-bottom: 8px;">售后服务</div>
									<div style="font-size: 14px; color: #666; margin-bottom: 20px;border-bottom: 1px dashed #eee;padding-bottom: 20px;">全天候，快速应答</div>
									
									<ul style="list-style: none; padding: 0; margin: 0;">
										<li style="display: flex; align-items: flex-start; margin-bottom: 20px;padding-top: 20px;">
											<div style="width: 28px; height: 28px; background: #e1f5ff; border-radius: 4px; display: flex; justify-content: center; align-items: center; margin-right: 12px; flex-shrink: 0;">
												<span style="color: #0288d1; font-size: 16px;">24</span>
											</div>
											<div style="font-size: 14px; color: #666;line-height: 18px;">
												<strong style="color: #333;height: 30px;line-height: 30px;">全天候响应</strong><br>
												提供7×24小时全天候不间断售后服务响应，多形式专业化的技术支持保障系统稳定运行。
											</div>
										</li>
										<li style="display: flex; align-items: flex-start; margin-bottom: 20px;padding-top: 20px;">
											<div style="width: 28px; height: 28px; background: #e1f5ff; border-radius: 4px; display: flex; justify-content: center; align-items: center; margin-right: 12px; flex-shrink: 0;">
												<span style="color: #0288d1; font-size: 16px;">🔍</span>
											</div>
											<div style="font-size: 14px; color: #666;line-height: 18px;">
												<strong style="color: #333;height: 30px;line-height: 30px;">定期诊断</strong><br>
												为软件系统、数据安全及服务等提供全面性的诊断检查，提前发现风险并提供改善方案。
											</div>
										</li>
										<li style="display: flex; align-items: flex-start; margin-bottom: 20px;padding-top: 20px;">
											<div style="width: 28px; height: 28px; background: #e1f5ff; border-radius: 4px; display: flex; justify-content: center; align-items: center; margin-right: 12px; flex-shrink: 0;">
												<span style="color: #0288d1; font-size: 16px;">⚠️</span>
											</div>
											<div style="font-size: 14px; color: #666;line-height: 18px;">
												<strong style="color: #333;height: 30px;line-height: 30px;">故障排除</strong><br>
												系统故障请拨打售后服务电话，我们的技术支持人员会在1小时内响应并解决问题。
											</div>
										</li>
										<li style="display: flex; align-items: flex-start;padding-top: 20px;">
											<div style="width: 28px; height: 28px; background: #e1f5ff; border-radius: 4px; display: flex; justify-content: center; align-items: center; margin-right: 12px; flex-shrink: 0;">
												<span style="color: #0288d1; font-size: 16px;">⬆️</span>
											</div>
											<div style="font-size: 14px; color: #666;line-height: 18px;">
												<strong style="color: #333;height: 30px;line-height: 30px;">系统升级</strong><br>
												不断对产品进行迭代升级，为企业客户提供系统升级服务，让客户享受最新的产品技术。
											</div>
										</li>
									</ul>
								</div>

								<div style="text-align: center;">
									<button style="padding: 10px 24px; background: #000; color: #fff; border: none; border-radius: 4px; cursor: pointer; width: 40%;">
									联系我们
								</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<Foot />
		</div>
	</div>
</template>

<script>
	import Nav from "./nav.vue";
	import Foot from "./foot.vue";

	export default {
		name: "App",
		components: {
			Nav,
			Foot
		},
		data() {
			return {
				curHeight: 0,
				index: 0,
				currentCard: 0, // 当前选中的服务卡片
				// 固定6张轮播图片（请替换成你的实际图片路径）
				caseImageList: [
					"../../assets/img/gywmImg1.png",
					"../../assets/img/gywmImg2.png",
					"../../assets/img/gywmImg3.png",
					"../../assets/img/gywmImg4.png",
					"../../assets/img/gywmImg5.png",
					"../../assets/img/gywmImg6.png",
				],
				currentImageIndex: 0
			};
		},
		watch: {
			windowHeight(val) {
				let that = this;
				console.log("实时屏幕高度：", val, that.windowHeight);
			},
		},
		beforeMount() {
			var h = document.documentElement.clientHeight || document.body.clientHeight;
			this.curHeight = h;
		},
		methods: {
			// 图片加载失败的处理函数
			handleImageError(e) {
				console.error("图片加载失败：", e.target.src);
				e.target.src = "https://picsum.photos/1000/400?random=0";
			},
			// 上一张图片
			prevImage() {
				if (this.currentImageIndex > 0) {
					this.currentImageIndex--;
				}
			},
			// 下一张图片
			nextImage() {
				if (this.currentImageIndex < this.caseImageList.length - 1) {
					this.currentImageIndex++;
				}
			},
			// 切换到指定图片
			switchImage(index) {
				this.currentImageIndex = index;
			},
			enter(e) {
				this.index = e;
			},
			leave() {
				this.index = 0;
			}
		},
		mounted() {
			var that = this;
			window.onresize = () => {
				window.fullHeight = document.documentElement.clientHeight;
				that.curHeight = window.fullHeight;
			};
			
			console.log("轮播图片列表：", this.caseImageList);
		},
	};
</script>

<style scoped>
	.main-content {
		min-height: 100%;
		min-width: 1400px;
		width: 100%;
		margin: 0 auto;
		display: block;
		position: absolute;
	}

	.center-body {
		margin: 0 auto;
	}

	/* 服务卡片hover效果 */
	.service-card {
		transition: all 0.3s ease;
	}
	.service-card:hover {
		transform: translateY(-5px);
		box-shadow: 0 8px 20px rgba(0,0,0,0.08);
	}
	.service-card.active {
		transform: translateY(-5px);
		box-shadow: 0 8px 20px rgba(0,0,0,0.08);
	}

	/* 其他样式保持不变 */
	.fixed-bottom {
		position: fixed;
		bottom: 0;
	}
	
	.hxyx-box {
		height: 793px;
		background-image: url(../../assets/img/gywmbg.png);
		background-size: 100% 100%;
		background-repeat: no-repeat;
		padding-top: 80px;
		text-align: center;
	}
	
	.mfty-box {
		height: 600px;
		background-color: #fff;
		padding-top: 60px;
		text-align: center;
	}
	
	.active {
		/* color: #fff !important;
		background-color: #0070FD !important; */
	}

	button:hover {
		color: #409eff !important;
	}

	img {
		transition: all 0.5s ease;
	}
	.container{
		background: url(./../../assets/img/jsfw.png);
		padding: 120px 0;
	}
</style>